export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";